import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';

import { useForm } from '../../hooks/useForm';
import ConfirmationModal from './ConfirmationModal';
import FormInput from './FormInput';
import { inputs } from './inputs';

const initialValues = {
  text: '',
  correctAnswer: '',
  incorrectAnswer1: '',
  answerLocation: '',
};

function SubmitAQuestionForm({
  submitNewQuestion,
  isUserQuestionsLoading,
  statusMessage,
  setUserQuestionsMessage,
  questionToEditValues = {},
  questionToEditInputs = {},
  handleResetQuestionToEdit,
  setSelectedQuestion,
  selectedQuestion,
  editSubmitQuestion,
}) {
  const isEditingQuestion = Object.keys(questionToEditValues).length > 0;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    formValue,
    formInputs,
    inputErrorMessage,
    handleAddInput,
    handleInputChange,
    handleSubmit,
    handleResetForm,
    handleResetInputErrors,
    setFormValue,
    setFormInputs,
  } = useForm({
    initialValues,
    inputs,
    submitNewQuestion,
    setUserQuestionsMessage,
    statusMessage,
    isEditingQuestion,
    setSelectedQuestion,
    selectedQuestion,
    editSubmitQuestion,
    handleResetQuestionToEdit,
  });

  useEffect(() => {
    if (isEditingQuestion) {
      setFormValue(questionToEditValues);
      setFormInputs(questionToEditInputs);
      handleResetInputErrors();
    } else {
      setFormValue(initialValues);
      setFormInputs(inputs);
      handleResetInputErrors();
    }
  }, [questionToEditValues, questionToEditInputs]);

  const handleCancelEdit = () => {
    setSelectedQuestion({});
    handleResetForm();
    handleResetQuestionToEdit();
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();

    if (!isEditingQuestion) {
      setIsModalOpen(true);
    } else {
      handleSubmit(e);
    }
  };

  return (
    <Row className="w-100">
      <Col md={12} className="d-flex justify-content-center">
        <form className="form" onSubmit={handleSubmitForm}>
          {isEditingQuestion ? <h3>Editing Question</h3> : null}
          {formInputs.map((input) =>
            input.hasAddButton ? (
              <FormInput
                key={input.id}
                input={input}
                handleInputChange={handleInputChange}
                value={formValue[input.name]}
                hasAddButton
                handleAddInput={handleAddInput}
              />
            ) : (
              <FormInput
                key={input.id}
                input={input}
                handleInputChange={handleInputChange}
                value={formValue[input.name]}
                errorMessage={inputErrorMessage[input.name]}
              />
            ),
          )}
          {statusMessage.type ? (
            <div
              className={`form__status-message--${statusMessage.type}`}
              data-test="submit-question-status-message-text"
            >
              {statusMessage.message}
            </div>
          ) : null}
          <div className="form__button__container">
            <button
              disabled={isUserQuestionsLoading}
              className="btn btn-primary btn-submit"
              type="submit"
              data-test="submit-a-quesion-form-button"
            >
              {isEditingQuestion ? 'Edit question' : 'Submit a Question'}
            </button>
            {isEditingQuestion ? (
              <button
                onClick={handleCancelEdit}
                className="list__item__delete-button btn btn-primary btn-add"
              >
                Cancel
              </button>
            ) : null}
          </div>
        </form>
        <ConfirmationModal
          isOpen={isModalOpen}
          toggle={() => setIsModalOpen((prev) => !prev)}
          handleSubmit={handleSubmit}
        />
      </Col>
    </Row>
  );
}

export default SubmitAQuestionForm;
